module.exports = __webpack_public_path__ + "img/main-banner.de2e50a5.png";